import React, { Component } from "react";

import firebase from './Fireb';
import { Card,Nav,Navbar, Form,FormControl ,Badge, InputGroupAddon, InputGroupText, Container, Button } from 'reactstrap';
import '../App.css';
import { Link } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import PropTypes from "prop-types";
import { ProductConsumer } from "../context";
import { FaWindows } from "react-icons/fa";
import moment from 'moment';
import logo from '../aplogo1.png'
import Title from "./Title";
import styled from "styled-components";
import { TextField } from '@material-ui/core';
import { ButtonContainer } from "./Button";
import Swal from 'sweetalert2';
import { ButtonContainer2 } from './Button'
class checkout extends Component {
  

  constructor(props) {
    super(props);
    this.state = {
      key: '',
      name: '',
      userid: '',
      amount: '',
      balance: '',
      vkey: '',
      vname: '',
      adminId: '',
      i: 0,
      Shop: '',
      push_token: '',
      chkbutton:false,
      p: 1
    };
   // this.ShowAlertWithDelay = this.ShowAlertWithDelay.bind(this);
   this.Cancel = this.Cancel.bind(this);
  }
  

  componentDidMount() {
    const ref1 = firebase.firestore().collection('vendor').doc(firebase.auth().currentUser.uid);
    ref1.get().then((doc) => {
      if (doc.exists) {
        const vendor = doc.data();
        this.setState({
          vkey: doc.id,
          vname: vendor.First_Name,
          adminId: vendor.adminId,
          Shop: vendor.Shop
        });
      }
      else {
       console.log("No such document!");
     }
     
   });
   
    const ref = firebase.firestore().collection('record').doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        const record = doc.data();
        this.setState({
          key: doc.id,
          name: record.name,
          userid: record.userid,
          amount: record.amount,
          check:record.check,
          status:record.status,
          push_token: record.push_token
        });  
      }
       else {
        console.log("No such document!");
      }
      
    });
   // this.ShowAlertWithDelay();
    
}
/*ShowAlertWithDelay=()=>{
 const state1 = this.state;
 console.log(state1)
  setTimeout(function(){
    this.setState({balance: this.state.amount - this.state.expense})
    console.log('fire')
    //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
   // Alert.alert("Alert Shows After 5 Seconds of Delay.")

  }, 5000);}*/

  Cancel() {
    window.location.assign('/');
  }


onChange = (e) => {
  const state = this.state
  state[e.target.name] = e.target.value;
  this.setState({record:state});

}
onClick() {
  const btnPrint = document.querySelector("#btnPrint");
  btnPrint.addEventListener("click", () => {
      window.print();
  });
  }

onSubmit = (e) => {

  e.preventDefault();
  const state = this.state
console.log(state);
console.log(this.state.firstc);
  const { name, userid, amount, } = this.state;

//const startDate = new Date();
const startDate = moment(new Date()).format("ll")
console.log(startDate)
  const updateRef = firebase.firestore().collection('record').doc(this.state.key);
  const updateRef2 = firebase.firestore().collection('History'); //.where("sid", "==", 'Ssb1PHw98SKuSg1iau80');
  const updateRef3 = firebase.firestore().collection('vendorPay').where("day", "==", startDate).where("vendoruid", "==", firebase.auth().currentUser.uid);

  updateRef.update({
    Prcheck: true,
    amount: this.state.balance,
      timestampt: new Date(),
  })
  updateRef2.add({
    expense: this.state.expense,
     //text:this.state.first+':'+ this.state.firstp +'*' +this.state.firstc +'='+  +this.state.firstT ,
     text:this.state.Names + ' : ' + this.state.Counts,
     createdAt: new Date(),
      uid:this.state.key,
      vid: firebase.auth().currentUser.uid,
      name: this.state.name,
      vendor: this.state.vname,
      adminId: this.state.adminId

    })
  .catch((error) => {
    console.error("Error adding document: ", error);
  });

  
    updateRef3.get().then(doc => {
      if(!doc.empty){
        doc.forEach((doc) => {
      const vendorPay = doc.data();
      const collection = firebase.firestore().collection('vendorPay')    
          const newDocumentBody = {
            tno: vendorPay.tno + this.state.p,
        Bill: vendorPay.Bill + this.state.expense
          }
          collection.where("vendoruid", "==", firebase.auth().currentUser.uid).where("day", "==", startDate).get().then(response => {
              let batch = firebase.firestore().batch()
              response.docs.forEach((doc) => {
                  const docRef = firebase.firestore().collection('vendorPay').doc(doc.id)
                  batch.update(docRef, newDocumentBody)
              })
              batch.commit().then(() => {
                  console.log(`updated all documents inside ${'vendorPay'}`)
                  window.location.assign('/');
                  Swal.fire({
                    icon: 'success',
                    title: 'Transaction completed!',
                    showConfirmButton: false,
                    timer: 1500
                      })
              })
          });
        })
    }  
    else {
      firebase.firestore().collection('vendorPay').add({
        vname: this.state.vname,
        Shop: this.state.Shop,
        tno: this.state.p,
       Bill: this.state.expense,
       status: 'Pending',
       check: true,
        day: moment(new Date()).format("ll"),
         vendoruid: firebase.auth().currentUser.uid,
         adminId: this.state.adminId,
         timestamp: new Date()
       })
       .then(() => {
        window.location.assign('/');
        Swal.fire({
          icon: 'success',
          title: 'Transaction completed!',
          showConfirmButton: false,
          timer: 1500
            })
       })
     .catch((error) => {
       console.error("Error adding document: ", error);
     });
    }
  })
  let message = {
    to: this.state.push_token,
      
    sound: 'default' ,
    title: 'Transaction Completed',
    body: "Rs." +this.state.expense+" Deducted from your card.Your new Balnce is Rs." +this.state.balance,

    data: { data: 'goes here' },
    _displayInForeground: true,
    
}
  let response = fetch('https://exp.host/--/api/v2/push/send', {
    method: 'POST',
  

    'mode': 'no-cors',
          'method': 'POST',
          'headers': {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
          },

        
    body: JSON.stringify(message)
    
  });


}
/*rendercheck(){

  if (this.state.check==true) {
 
  return(
    <ProductConsumer>
        {value => {
           
         
         const{cart}=value
         //console.log(value)

         const Names = cart.map(e => e.title).join(' , ' );
         const Counts = cart.map(e => e.count).join(' , ');
      
       this.state.Names=Names;
       this.state.Counts=Counts;

         //this.state.cart=cart;
          const{cartTotal, cartTax, cartSubTotal}=value;
        this.state.expense=cartTotal;
        
        var first = cart[0];
        this.state.firstc=first.count
        this.state.firstT=first.total


        this.state.Tax=cartTax
        this.state.Subtotal=cartSubTotal
        //console.log(this.state.Subtotal)
    /*    var first = cart[0];
        this.state.first=first.title
        this.state.firstc=first.count
        this.state.firstT=first.total
        this.state.firstp=first.price*/
       
      //const stringData = cart.reduce((result, item) => {
  //return `${result}${item.lat},${item.lon}|`
//}, "")
        
        /*  return (
    
    
       
          
            
            
            <Container >
              <title> Order confirmation </title>
<meta name="robots" content="noindex,nofollow" />
<meta name="viewport" content="width=device-width; initial-scale=1.0;" />
<form onSubmit={this.onSubmit}>
<div ref={el => (this.componentRef = el)}>
<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1">
  <tr>
    <td height="20"></td>
  </tr>
  <tr>
    <td>
      <table width="600" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff" style={{borderRadius: '10px 10px 0 0'}}>
        <tr class="hiddenMobile">
          <td height="40"></td>
        </tr>
        <tr class="visibleMobile">
          <td height="30"></td>
        </tr>

        <tr>
          <td>
            <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
              <tbody>
                <tr>
                  <td>
                    <table width="220" border="0" cellpadding="0" cellspacing="0" align="left" class="col">
                      <tbody>
                        <tr>
                          <td align="left"> <img src={logo} alt="logo" border="0" /></td>
                        </tr>
                        <tr class="hiddenMobile">
                          <td height="40"></td>
                        </tr>
                        <tr class="visibleMobile">
                          <td height="20"></td>
                        </tr>
                        <tr>
                          <td style={{fontSize: '12px', color: '#5b5b5b', fontFamily: 'Open Sans, sans-serif', lineHeight: '18px', verticalAlign: 'top', textAlign: 'left'}}>
                            {this.state.Shop} 
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="220" border="0" cellpadding="0" cellspacing="0" align="right" class="col">
                      <tbody>
                        <tr class="visibleMobile">
                          <td height="20"></td>
                        </tr>
                        <tr>
                          <td height="5"></td>
                        </tr>
                        <tr>
                          <td style={{fontSize: '21px', color: '#efc729', letterSpacing: '-1px', fontFamily: 'Open Sans, sans-serif', lineHeight: 1, verticalAlign: 'top', textAlign: 'right'}}>
                            Invoice  {this.state.i+=1}
                          </td>
                        </tr>
                        <tr>
                        <tr class="hiddenMobile">
                          <td height="50"></td>
                        </tr>
                        <tr class="visibleMobile">
                          <td height="20"></td>
                        </tr>
                        <tr>
                          <td style={{fontSize: '12px', color: '#5b5b5b', fontFamily: 'Open Sans, sans-serif', lineHeight: '18px', verticalAlign: 'top', textAlign: 'right'}}>
                            <small>ORDER</small> {this.state.i+=1}<br />
                            <small>Created:</small> {moment(Date()).format("lll")}<br></br>
                          </td>
                        </tr>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>

<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1">
  <tbody>
    <tr>
      <td>
        <table width="600" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff">
          <tbody>
            <tr>
            <tr class="hiddenMobile">
              <td height="60"></td>
            </tr>
            <tr class="visibleMobile">
              <td height="40"></td>
            </tr>
            <tr>
              <td>
                <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
                  <tbody>
                    <tr>
                      <th style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', fontWeight: 'normal', lineHeight: '18px', verticalAlign: 'top', padding: '0 10px 7px 0', textAlign: 'center'}} width="52%" align="left">
                        Product Description
                      </th>
                      <th style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', fontWeight: 'normal', lineHeight: '18px', verticalAlign: 'top', padding: '0 10px 7px 0', marginLeft: '5px'}} align="center">
                        Quantity
                      </th>
                      <th style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', fontWeight: 'normal', lineHeight: '18px', verticalAlign: 'top', padding: '0 10px 7px 0', marginLeft: '5px'}} align="right">
                        Subtotal
                      </th>
                    </tr>
                    <tr>
                      <td height="1" style={{background: '#bebebe'}} colspan="4"></td>
                    </tr>
                    <tr>
                      <td height="10" colspan="4"></td>
                    </tr>
                    <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#efc729', lineHeight: '18px', verticalAlign: 'top', textAlign: 'center', padding: '10px 0',  }} class="article">
                        {this.state.Names}
                      </td>
                      
          <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '18px', verticalAlign: 'top', textAlign: 'center', padding: '10px 0',  }} align="center">{this.state.Counts}</td>
          <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#1e2b33', lineHeight: '18px', verticalAlign: 'top', textAlign: 'center', padding: '10px 0',  }} align="right">{this.state.Subtotal}</td>
                    </tr>
                    <tr>
                      <td height="1" colspan="4" style={{borderBottom: '1px', solid: '#e4e4e4'}}></td>
                    </tr>
                    <tr>
                      <td height="1" colspan="4" style={{borderBottom:'1px solid #e4e4e4'}}></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td height="20"></td>
            </tr>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>

<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1">
  <tbody>
    <tr>
      <td>
        <table width="600" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff">
          <tbody>
            <tr>
              <td>

              
                <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
                  <tbody>
                  <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        Vendor
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right',whiteSpace: 'nowrap' }} width="80">
                        {this.state.vname}
                      </td>
                    </tr>
                  <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        Student
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right',whiteSpace: 'nowrap' }} width="80">
                        {this.state.name}
                      </td>
                    </tr>
                  <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        Amount in wallet
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right',whiteSpace: 'nowrap' }} width="80">
                        {this.state.amount}
                      </td>
                    </tr>
                    <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        Subtotal
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#646a6e', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right',whiteSpace: 'nowrap' }} width="80">
                        {this.state.Subtotal}
                      </td>
                    </tr>
                    
                    <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}><small>DISCOUNT</small></td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
          <small>{this.state.Tax}</small>
                      </td>
                    </tr>
                    <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        <strong>Grand Total (Incl.Discount)</strong>
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
          <strong>{this.state.expense}</strong>
                      </td>
                       </tr>
                       <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        <strong>Remaining Balance</strong>
                      </td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                      
          <strong><TextField value={this.state.balance} onChange={this.onChange} onClick={(e)=>{this.setState({balance: this.state.amount - this.state.expense, chkbutton :true})}} required/></strong>
          
                      </td>
                       </tr>
                    <tr>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}><small></small></td>
                      <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#b0b0b0', lineHeight: '22px', verticalAlign: 'top', textAlign: 'right' }}>
                        <small></small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              

              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>

<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1">
  <tbody>
    <tr>
      <td>
        <table width="600" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff">
          <tbody>
            <tr>
            <tr class="hiddenMobile">
              <td height="60"></td>
            </tr>
            <tr class="visibleMobile">
              <td height="40"></td>
            </tr>
            <tr>
              <td>
                <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
                  <tbody>
                    <tr>
                      <td>
                        <table width="220" border="0" cellpadding="0" cellspacing="0" align="left" class="col">

                          <tbody>
                            <tr>
                              <td style={{fontSize: '11px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', lineHeight: 1, verticalAlign: 'top' }}>
                                <strong>BILLING ADDRESS</strong>
                              </td>
                            </tr>
                            <tr>
                              <td width="100%" height="10"></td>
                            </tr>
                            <tr>
                              <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', lineHeight: '20px', verticalAlign: 'top' }}>
                              ST-13 Abul Hasan Isphahani Rd<br></br>
                              Usman Institute of Technology<br></br>
                              </td>
                            </tr>
                          </tbody>
                        </table>


                        <table width="220" border="0" cellpadding="0" cellspacing="0" align="right" class="col">
                          <tbody>
                            <tr class="visibleMobile">
                              <td height="20"></td>
                            </tr>
                            <tr>
                              <td style={{fontSize: '11px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', lineHeight: 1, verticalAlign: 'top' }}>
                                <br></br>
                                <strong>PAYMENT METHOD</strong>
                              </td>
                            </tr>
                            <tr>
                              <td width="100%" height="10"></td>
                            </tr>
                            <tr>
                              <td style={{fontSize: '12px', fontFamily: 'Open Sans, sans-serif', color: '#5b5b5b', lineHeight: '20px', verticalAlign: 'top' }}>
                                Student Card
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
                  <tbody>
                    <tr>
                      <td>
                        <table width="220" border="0" cellpadding="0" cellspacing="0" align="left" class="col">
                          <tbody>
                            <tr class="hiddenMobile">
                              <td height="35"></td>
                            </tr>
                            <tr class="visibleMobile">
                              <td height="20"></td>

                              </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr class="hiddenMobile">
              <td height="60"></td>
            </tr>
            <tr class="visibleMobile">
              <td height="30"></td>
            </tr>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>

<table width="100%" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#e1e1e1">

  <tr>
    <td>
      <table width="600" border="0" cellpadding="0" cellspacing="0" align="center" class="fullTable" bgcolor="#ffffff" style={{borderRadius: '0 0 10px 10px'}}>
        <tr>
          <td>
            <table width="480" border="0" cellpadding="0" cellspacing="0" align="center" class="fullPadding">
              <tbody>
                <tr>
                  <td style={{fontSize: '12px', color: '#cb2353', fontFamily: 'Open Sans, sans-serif', lineHeight: '18px', verticalAlign: 'top', textAlign: 'left'}}>
                    Have a nice day.
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr class="spacer">
          <td height="50"></td>
        </tr>

      </table>
    </td>
  </tr>
  <tr>
    <td height="20"></td>
  </tr>
</table>
</div>
<button class="btn btn-danger"  onClick={this.Cancel}> Cancel</button>
{this.state.chkbutton?
 <Button outline color="warning" class= "check" type="submit" value={this.state.balance} style={{marginLeft: '900px'}} onClick={(e)=>{this.setState({submit: this.state.amount =  this.state.balance})}} >Checkout</Button>
: <Button outline color="secondary" class= "check" style={{marginLeft: '900px'}} >Checkout</Button>
 }

                  
                  
                </form>
                <div style={{textAlign: 'right'}}>
                <ReactToPrint
              trigger={() => <ButtonContainer href="#" class="a" >Print Receipt!</ButtonContainer>}
              content={() => this.componentRef}
            />
            </div>
          
              </Container>*/

        /*    <div class="panel-body">
              <form onSubmit={this.onSubmit}>
                    <h2 style={{color:'#cb2353'}}>{this.state.name}</h2>
          <h2>Vendor Name: {this.state.vname}</h2>
                  <div class="form-group">
                  <h2 onChange={this.onChange}>Current Balance: {this.state.amount}</h2>
                  <h2 onChange={(e)=>{this.setState({expense: e.target.value})}}>Billing Amount: {this.state.expense}</h2>
               <div ref={el => (this.componentRef = el)}>
                   <aside  style={{float: 'center', width: '70%', marginLeft: '200px'}}>
     <div class="invoice-box" style={{float: 'center', width: '70%'}} >
             <table cellpadding="0" cellspacing="0">
         <tr class="top">
             <td colspan="2">
                 <table>
                     <tr>
                             <img src={logo} />
                         <td>
                             Invoice #: {this.state.i+=1} <br></br>
                            Created: {moment(Date()).format("lll")}<br></br>
                         </td>
                     </tr>
                 </table>
             </td>
         </tr>
         <tr class="information">
             <td colspan="4">
                 <table>
                     <tr>
                         <td>
                         ST-13 Abul Hasan Isphahani Rd<br></br>
                         </td>
                         <br></br>
                         <br></br>
                         <br></br>
                         <br></br>
                         
                         <td>
                             Usman Institite of Technology<br></br>
                             www.uit.edu
                         </td>
                     </tr>
                 </table>
             </td>
         </tr>
         <tr class="heading">
             <td>
                 Amount in wallet
             </td>

             <td>
             {this.state.amount}
             </td>
         </tr>
         
         <tr class="details">
             <td>
                 Discount
             </td>
             
             <td>
             {this.state.Tax}
             </td>
             
         </tr>
         
         <tr class="item">
             <td>
               SubTotal
             </td>
             
             <td>
             {this.state.Subtotal}
             </td>
         </tr>
         
         <tr class="item">
             <td>
                 Description
             </td>
             
             <td>
             {this.state.Names} : {this.state.Counts}
             </td>
         </tr>
         <tr class="item">
             <td>
                 Total
             </td>
             
             <td>
             {this.state.expense}
             </td>
         </tr>
         
         <tr class="total">
             <td></td>
             
             <td>
                Remaining Balance:   <input placeholder="Remaining Balance" name="balance" type="text" value={this.state.balance} onChange={this.onChange} onClick={(e)=>{this.setState({balance: this.state.amount - this.state.expense})}}/>
             </td>
         </tr>
         </table>    
           </div>
           </aside>

                  </div>
                <Button outline color="warning" class= "check" type="submit" value={this.state.balance} onClick={(e)=>{this.setState({submit: this.state.amount =  this.state.balance})}}>Checkout</Button>
                    <button class="btn btn-danger"   >Cancel</button>
                  </div>
                  <div>
            
          </div>
                </form>
              </div>
        /*        <ReactToPrint
              trigger={() => <a href="#" class="a" >Print Receipt!</a>}
              content={() => this.componentRef}
            />*/
          
          //    </Container>
            
            
          

/*);
}}
</ProductConsumer>
        );
  
  }
}*/
rendercheck2(){
  if (this.state.check==true) {
 
    return(
  <ProductConsumer>
        {value => {
           
         
         const{cart}=value
         //console.log(value)

         const Names = cart.map(e => e.title).join(' , ' );
         const Counts = cart.map(e => e.count).join(' , ');
      
       this.state.Names=Names;
       this.state.Counts=Counts;

         //this.state.cart=cart;
          const{cartTotal, cartTax, cartSubTotal}=value;
        this.state.expense=cartTotal;
        
        var first = cart[0];
        this.state.firstc=first.count
        this.state.firstT=first.total


        this.state.Tax=cartTax
        this.state.Subtotal=cartSubTotal
  return(
    <Container>
      <form onSubmit={this.onSubmit}>
    <div class="ticket">
    <img class="one" src={logo} alt="Logo"/>
    <p class="centered">PAYMENT RECEIPT</p>

                            <br/>Invoice #: {this.state.i+=1} <br></br>
                            Created: {moment(Date()).format("lll")}<br></br>
  <br></br> {this.state.Shop}-----{this.state.vname}
  <br></br> {this.state.name}
                         
        <br/>Usman Institite of Technology<br></br>
        <br/>
    <table>
    
        <thead>
            <tr>
                <th class="description">Q.</th>
                <th class="quantity">Desc</th>
                <th class="description">SubT</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td class="quantity">{this.state.Counts}</td>
  <td class="description">{this.state.Names}</td>
  <td class="price">{this.state.Subtotal}</td>
          
            </tr>
        </tbody>
        <thead>
            <tr>
                <th class="description">Wal.</th>
                <th class="description">Tax</th>
                <th class="description">Bill</th>
            </tr>
        </thead>
        <tbody>
            <tr>
  

                <td class="quantity">{this.state.amount}</td>
                <td class="description">{this.state.Tax}</td>
                <td class="description">{this.state.expense}</td>
          
            </tr>
        </tbody>
    </table>
    <br></br>
    Remaining Bal: <TextField value={this.state.balance} onChange={this.onChange} onClick={(e)=>{this.setState({balance: this.state.amount - this.state.expense, chkbutton :true})}} required/>
    <p class="centered">Thanks for using cashless!</p>

                  
                  
    
<script src="script.js"></script>

</div>
<div class="hidden-print">
<Button color="danger"style={{marginLeft: '400px', position: "absolute"}} class="hidden-print" onClick={this.Cancel}> Cancel</Button>
{this.state.chkbutton?
 <Button  color="warning" class="hidden-print" class= "check" type="submit" value={this.state.balance} style={{marginLeft: '677px', position: "absolute"}} onClick={(e)=>{this.setState({submit: this.state.amount =  this.state.balance})}} >Checkout</Button>
: <Button  color="secondary" class="hidden-print" class= "check" style={{marginLeft: '677px', position: "absolute"}} >Checkout</Button>
 }
 </div>
</form>
<div class="hidden-print">
<ButtonContainer2 style={{marginLeft: "504px"}}>
  <label onClick={this.onClick.bind(this)}>
  <button hidden id="btnPrint" class="hidden-print" style={{backgroundImage: "linear-gradient(to left, #000428 , #004e92)",
       color: "#d9b74c",
       fontSize: "14px",
       cursor: "pointer",
       padding: "10px",
       margin: "5px",
 transition: "all .5s ease-in-out"}}>Print Reciept</button>
Print Reciept
</label>
</ButtonContainer2>
</div>

</Container>

);
}}
</ProductConsumer>
         
    );
}
}
      
render() {
  return (
    <React.Fragment>
        <ProductWrapper className="py-5">
          <div className="container">
            <div class="hidden-print">
            <Title name="student" title="Checkout" />
         </div>
   <div>
  {this.rendercheck2()}
  
  
      </div>
      </div>
        </ProductWrapper>
      </React.Fragment>
    );
  }

  }

  const ProductWrapper = styled.section``;
export default checkout;






